import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { EMPLOYEE_BLUE, WHITE, PINK_RED } from "../colors";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
import Autocomplete from "@mui/material/Autocomplete";
import HeightBox from "./HeightBox";
import CustomerService from "../services/customerService";
import RemarkService from "../services/remarkService";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomers } from "../actions/customers";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Radio, RadioGroup } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  bgcolor: "#E1DEDE",
  boxShadow: 24,
  p: 4,
  borderRadius:4,
};

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 430,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  height: 40,
  minWidth: 180,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  color: WHITE,
}));

const CustomPaper = styled(Paper)(({ theme }) => ({
  height: 100,
  minWidth: 435,
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: WHITE,
}));

export default function AddRemarkModal(props) {
  const dispatch = useDispatch();

  const customerList = useSelector((state) => state.customerList);
  const { customers: customersStore } = customerList;
  const { cancelFunction, openModel, handleCancelModel } = props;
  const [value, setValue] = React.useState();
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [formData, setFormData] = React.useState({
    customer: "",
    description: "",
    timeCreated: new Date(),
  });
  // After the api call setLoading should be make to false
  useEffect(() => {
    const getPageInfo = async () => {
      if (customersStore === null) {
        dispatch(getAllCustomers());
      }
      const temp = customersStore?.map((item) => {
        return { label: item.full_name, value: item.id };
      });

      setCustomers(temp);
    };

    getPageInfo();
  }, []);
  const createRemark = async () => {
    setLoading(true);

    try {
      const res = await RemarkService.createRemark(formData);

      setFormData({
        customer: "",

        description: "",
        timeCreated: new Date(),
      });

      if (res.status === 201) {
        setLoading(false);
        const message = "Remark created successfully";

        alert(message);

        cancelFunction();
      } else {
        setLoading(false);
        // message = res.message;
        alert("Remark creation failed");
      }
    } catch (err) {
      setFormData({
        customer: "",

        description: "",
        timeCreated: new Date(),
      });
      setLoading(false);
      alert("Remark creation failed");
    }
  };
  return (
    <Modal
      open={openModel}
      onClose={handleCancelModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
      <IconButton
          aria-label="delete"
          onClick={cancelFunction}
          sx={{ position: "absolute", right: "20px", top: "20px" }}
        >
          <CloseIcon />
        </IconButton>

        <Typography id="modal-modal-title" variant="h6" component="h2">
          Add remark
        </Typography>
        <HeightBox height={40} />
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          onChange={(event, value) => {
            setFormData({
              ...formData,
              customer: value?.value,
            });
          }}
          value={formData.customer}
          options={customers}
          renderInput={(params) => <CustomTextField {...params} placeholder="Select Customer " />}
        />
        <HeightBox height={20} />
        <CustomTextField
          multiline
          rows={4}
          placeholder="Type the description here"
          onChange={(e) => {
            setFormData({
              ...formData,
              description: e.target.value,
            });
          }}
          value={formData.description}
        />
        <HeightBox height={20} />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateTimePicker
            renderInput={(props) => <CustomTextField placeholder="Date and Time" {...props} />}
            onChange={(e) => {
              setFormData({
                ...formData,
                timeCreated: e.target.value,
              });
            }}
            value={formData.timeCreated}
          />
        </LocalizationProvider>
        <HeightBox height={20} />
        <Stack direction="row" alignItems="center" spacing={3}>
          <CustomButton
            style={{ backgroundColor: PINK_RED }}
            onClick={() => {
              cancelFunction();
            }}
          >
            Cancel
          </CustomButton>
          <CustomButton
            style={{ backgroundColor: EMPLOYEE_BLUE }}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              createRemark();
            }}
          >
            {loading ? <CircularProgress size={15} /> : "Submit"}
          </CustomButton>
        </Stack>
      </Box>
    </Modal>
  );
}
